export default "__VITE_ASSET__iohnAedK__"